import * as types from './mutation-types';
import cookie from '../../static/js/cookie';

// 类似于事件 每个mutation都有字符类型的事件类型和回调函数
//全局引入vue
import Vue from 'vue';
import Axios from 'axios';
import {getUserOrganization, getUserPerson} from "../api/api";
import {filterUnderLine} from "../../static/js/util";


export default {
  // ✅ 修复：接收 data 参数，合并数据而不是只从 cookie 读取
  [types.SET_INFO](state, data) {
    // 如果传入了数据，合并到 userInfo
    if (data && Object.keys(data).length > 0) {
      state.userInfo = {
        ...state.userInfo,
        ...data
      };
    } else {
      // 如果没有传入数据，从 cookie 读取
      state.userInfo = {
        name: cookie.getCookie('name'),
        token: cookie.getCookie('token'),
        uid: cookie.getCookie('uid'),
        part: cookie.getCookie('part'),
        mid: cookie.getCookie('mid'),
        id: cookie.getCookie('id'),
        member_id: cookie.getCookie('member_id'),
        user_id: cookie.getCookie('user_id'),
      };
    }
    console.log('SET_INFO 更新后的 userInfo:', state.userInfo);
  },

  [types.SET_PER](state) {
    if (cookie.getCookie('part') !== 'O') {
      getUserPerson(cookie.getCookie('uid'))
        .then(res => {
        state.person.person = filterUnderLine(res.data);

      }).catch(err=>{console.log(err)});
    }
  },

  [types.SET_ORG](state) {
    if (cookie.getCookie('part') ==='O') {
      getUserOrganization(cookie.getCookie('uid')).then(res => {
        state.org.org = filterUnderLine(res.data);


      }).catch(err=>{console.log(err)});
    }
  },


  [types.SET_URL](state, url) {
   state.url = url
  },

  // [types.SAVE_SOCK](state, obj) {
  //   // console.log(state.socketId)
  //   state.socketId.socketId = obj
  //
  //   // console.log(state.socketId)
  //   // console.log(state.socketId.queueCount)
  //   // console.log(state.socketId.socketId)
  // },
  //
  // [types.RESET_SOCK](state) {
  //   state.socketId.socketId = null
  //
  // },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js